<template>
  <div class="folder" :style="style">
    <div class="folder-name">
      <div class="icone" @click="vendaInsumoConsumoItemMostrarOcultarConsumo" :key="mostrar" :class="([ '', null, undefined ].indexOf(cpntConsumo) !== -1) ? 'disabled' : ''">
        <svg v-if="mostrar === false || [ '', null, undefined ].indexOf(cpntConsumo) !== -1" class="far fa-folder"></svg>
        <svg v-else-if="mostrar === true" class="far fa-folder-open"></svg>
      </div>

      <span v-html="vendaInsumoConsumoItemFormatarValor(cpntItem.qtde, false)"></span>
      <span v-html="' ' + vendaInsumoConsumoCarregarValor('id_uni')"></span>
      
      <span v-html="' x '"></span>

      <span @click="vendaInsumoConsumoItemAbrirCadastro">
        <span v-html="vendaInsumoConsumoCarregarValor('nome')"></span>

        <b v-if="vendaInsumoConsumoCarregarValor('status') !== '1'" v-html="'[Excluído]'"></b>
      </span>

      <span class="custo" v-if="cpntPermissaoMostrarValorCusto === true">
        <span v-html="' (' + vendaInsumoConsumoItemFormatarValor(cpntItem.custo_total) + ')'"></span>
      </span>

      <!-- SETA O BOTÃO PARA DETALHAMENTO DO CUSTO -->
      <App-Button v-if="[ '', null, undefined ].indexOf(cpntConsumo) !== -1" :data-time="time" style="margin: 2px; padding: 2px 3px;" :cpntIcone="'info'" title="Clique aqui para as informações do custo" @onClick="() => { detalheCusto = cpntItem } " ref="btDialogRel"></App-Button>
    </div>

    <template v-if="[ '', null, undefined ].indexOf(cpntConsumo) === -1 && mostrar === true">
      <Venda-Insumo-Consumo-Item-Recursivo v-for="item in cpntConsumo" :key="item.id"
      :cpntNivel="cpntNivel + 1"
      :cpntItem="item"
      :cpntConsumo="item.insumo_consumo"
      :cpntPermissaoMostrarValorVenda="cpntPermissaoMostrarValorVenda"
      :cpntPermissaoMostrarValorCusto="cpntPermissaoMostrarValorCusto"
      ></Venda-Insumo-Consumo-Item-Recursivo>
    </template>

    <App-Relatorio-Detalhe-Custo v-if="detalheCusto !== null"
    :cpntDetalhe="detalheCusto"
    :cpntFecharFormulario="() => { detalheCusto = null }"
    ></App-Relatorio-Detalhe-Custo>
  </div>
</template>

<style scoped>
</style>

<style>
.folder {
  display: flex;
  flex-direction: column;
  margin: 0px 0px 0px 5px;
}
.folder-name {
  font-weight: bold;
  padding: 5px;
  cursor: pointer;
}
.folder .folder {
  margin-left: 20px;
  /* border-left: 2px solid #cfcfcf; */
}
.folder-name > div {
  text-align: left;
  display: inline-block;
  padding: 5px 0px;
  vertical-align: middle;
}
  .folder-name > div > .titulo {
    opacity: 0.85;
  }
  .folder-name > div > span {
    font-weight: bold;
    text-shadow: none;
  }
  .folder-name > .icone.disabled {
    cursor: no-drop;
  }
    .folder-name > .icone.disabled > svg {
      /* color: #ccc */
      opacity: 0.6;
    }
  .folder-name > .icone {
    margin-right: 5px;
  }
  .folder-name > .icone > svg {
    font-size: 25px;
  }
  .folder-name > .custo {
    font-size: calc(100% - 2px);
  }
</style>

<script>
  export default {
    name: 'Venda-Insumo-Consumo-Item-Recursivo',
    props: {
      cpntHashId: {
        required: false,
        default: function () {
          // INICIA A VARIAVEL ID
          var hash = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            hash = 'ins-con-ven-item-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString()

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(hash)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return hash
        }
      },
      cpntItem: {
        required: true,
        type: Object
      },
      cpntNivel: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntConsumo: {
        type: Array
      },
      cpntPermissaoMostrarValorVenda: {
        required: true,
        type: Boolean,
      },
      cpntPermissaoMostrarValorCusto: {
        required: true,
        type: Boolean,
      },
      cpntIniciarMostrando: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      },
    },
    components: {
      'App-Relatorio-Detalhe-Custo': () => import('@/components/produto/relatorios/Relatorio-Detalhe-Custo.vue')
    },
    data: function () {
      return {
        time: '',
        itens: [],
        style: '',
        custo: '',
        mostrar: false,
        detalheCusto: null
      }
    },
    mounted: function () {
      this.mostrar = this.cpntNivel === 0
    },
    methods: {
      vendaInsumoConsumoItemMostrarOcultarConsumo: function () {
        this.mostrar = !this.mostrar
      },
      vendaInsumoConsumoItemFormatarValor: function (value, sifra = true) {
        // INICIA O VALOR
        var valor = '0,00'

        // FORMATA O VALOR SOLICITADO
        if ([ '', null, undefined ].indexOf(value) === -1) {
          valor = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', value)
        }

        // RETORNA O VALOR CALCULADO
        return (sifra === true ? 'R$ ' : '') + valor
      },
      vendaInsumoConsumoCarregarValor: function (chave) {
        // TRATA O VALOR RECEBIDO
        if (chave !== '') {
          chave = '_' + chave
        }

        // PEGA O VALOR RECEBIDO
        if ([ '', null, undefined ].indexOf(this.cpntItem['id_pro' + chave]) === -1) {
          return this.cpntItem['id_pro' + chave]
        } else if ([ '', null, undefined ].indexOf(this.cpntItem['id_pro_consumido' + chave]) === -1) {
          return this.cpntItem['id_pro_consumido' + chave]
        } else {
          return '<b style="color: red;"> (ERRO AQUI) </b>'
        }
      },
      vendaInsumoConsumoItemAbrirCadastro: function () {
        // INICIA OS PARAMETROS
        var params = { acao: 'ABRIR_CADASTRO', tipo: 'produto', id: this.vendaInsumoConsumoCarregarValor("") }

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO', params)
      },
      vendaInsumoConsumoItemGerarCores: function (id) {
        // IMPORTA A FUNÇÃO DEPENDENTE
        const FUN_PEGAR_CORES = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CORES

        // CRIA AS CORES PARA CHAVE INFORMADA
        FUN_PEGAR_CORES('ins-con-' + id, (vetor) => {
          // INICIA A VARIAVEL DA STRING
          var style = []

          // ADICIONA A COR DO FUNDO
          style.push('background: ' + vetor.fundo + ';')

          // ADICIONA A COR DA LETRA
          style.push('color: ' + vetor.letra + ';')

          // ADICIONA A BORDA
          style.push('border-top: 1px solid ' + vetor.borda + ';')

          // SETA SE DEVE TER CANTOS ARREDONDADOS
          if (this.cpntIniciarMostrando === true) {
            style.push('border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;')
          }

          // SETA O CSS MONTADO
          this.style = style.join(' ')
        })
      },
    }
  }
</script>
